import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { DbEnums } from '@eluve/graphql-types';

import {
  appointmentTagKeySchema,
  appointmentTagTypeSchema,
} from './appointment-tags';

const c = initContract();

export const adminAppointmentContract = c.router(
  {
    deleteAppointmentAssets: {
      method: 'POST',
      path: '/asset-deletion/:tenantId/:appointmentId',
      body: z.object({
        jobType: z.enum([
          DbEnums.AssetDeletionJobType.AUDIO_FOR_APPOINTMENT,
          DbEnums.AssetDeletionJobType.TRANSCRIPTS_AND_AUDIO_FOR_APPOINTMENT,
          DbEnums.AssetDeletionJobType.APPOINTMENT_OUTPUTS,
        ]),
      }),
      responses: {
        201: z.object({
          jobId: z.string(),
          willRunAt: z.date().optional(),
        }),
        400: z.object({
          message: z.string(),
        }),
      },
    },
    getAppointmentFileSignedUrl: {
      method: 'GET',
      path: '/file/:tenantId/:appointmentId/:fileId',
      responses: {
        200: z.object({
          presignedUrl: z.string().nullable(),
        }),
      },
      summary:
        'Requests a presigned GCS Url for downloading an appointment file',
    },
    overrideAudioFileAndTranscriptAsCancelled: {
      method: 'PATCH',
      path: '/file/:tenantId/:appointmentId/:fileId',
      responses: {
        200: z.object({
          transcriptUpdated: z.boolean(),
          audioFileUpdated: z.boolean(),
        }),
      },
      body: z.object({}),
    },
    addAppointmentTag: {
      method: 'POST',
      path: '/:tenantId/:appointmentId/tags',
      responses: {
        200: z.object({}),
      },
      body: z.object({
        type: appointmentTagTypeSchema,
        key: appointmentTagKeySchema,
        fileId: z.string().uuid().optional(),
        metadata: z.record(z.unknown()).optional(),
      }),
      summary: 'Add a tag to an appointment',
    },
  },
  { pathPrefix: '/admin-appointment' },
);
